export const GENDER = ['Male', 'Female', 'Other', 'Wont-say'] as const;
